import { Suspense, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { SideBar } from '../components/SideBar';
import { SideBarContext } from '../context/SideBarContext';
import { Map } from '../components/Map/Map';
import { Spinner } from 'react-bootstrap';
import { TasksManager } from '../components/Dashboard/TasksManager';
import { BranchesProvider } from '../context/BranchesContext';
import { ReflexContainer, ReflexElement, ReflexSplitter } from 'react-reflex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { NewRequestProvider } from '../context/NewRequestContext';
import { NewRequestPlaceholder } from '../components/PlaceHolders/NewRequestPlaceholder';
import { OptionsProvider } from '../context/OptionsContext';
import ErrorBoundary from '../components/ErrorBoundary';
import { ErrorComponent } from '../components/ErrorComponent';
export const Dashboard = () => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { sideBarVissible } = useContext(SideBarContext);

    return (
        <div className={`d-flex wrapper ${sideBarVissible && 'sidebar-active'} w-100`}>
            <SideBar>
                <Navigation />
            </SideBar>
            <div className='d-flex content-wrapper flex-column justify-content-start bg-light align-items-start w-100'>
                <Header title={t('dashboard')} />
                <div className='d-flex dashboard-container flex-wrap flex-row bg-light w-100'>
                    <Suspense
                        fallback={
                            <div className='w-100 vh-100 background-secondary d-flex justify-content-center align-items-center'>
                                <Spinner animation='border' />
                            </div>
                        }
                    >
                        <BranchesProvider>
                            <NewRequestProvider>
                                <ReflexContainer orientation='vertical' className='w-100'>
                                    <ReflexElement className='left-pane h-100' minSize={250} flex={0.3}>
                                        <OptionsProvider>
                                            <TasksManager></TasksManager>
                                        </OptionsProvider>
                                    </ReflexElement>

                                    <ReflexSplitter className='d-flex justify-content-center flex-column align-items-center '>
                                        <FontAwesomeIcon
                                            icon={faArrowAltCircleRight}
                                            style={{ height: '20px', padding: '0px 2px' }}
                                            className='bg-dark rounded-top'
                                            color='white'
                                            size='sm'
                                        ></FontAwesomeIcon>
                                        <FontAwesomeIcon
                                            icon={faArrowAltCircleLeft}
                                            style={{ height: '20px', padding: '0px 2px' }}
                                            className='bg-dark rounded-bottom'
                                            color='white'
                                            size='sm'
                                        ></FontAwesomeIcon>
                                    </ReflexSplitter>

                                    <ReflexElement className='right-pane'>
                                        <div className='map-container w-100 position-relative'>
                                            <ErrorBoundary fallback={<ErrorComponent errorText={t('map')} />}>
                                                <Suspense fallback={<NewRequestPlaceholder />}>
                                                    <Map />
                                                </Suspense>
                                            </ErrorBoundary>
                                        </div>
                                    </ReflexElement>
                                </ReflexContainer>
                            </NewRequestProvider>
                        </BranchesProvider>
                    </Suspense>
                </div>
            </div>
        </div>
    );
};
